import { render, staticRenderFns } from "./DeleteBusinessUnitPopup.vue?vue&type=template&id=5911fbf2"
import script from "./DeleteBusinessUnitPopup.vue?vue&type=script&lang=js"
export * from "./DeleteBusinessUnitPopup.vue?vue&type=script&lang=js"
import style0 from "./DeleteBusinessUnitPopup.vue?vue&type=style&index=0&id=5911fbf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports